import { Controller, MainMenu, Toolbar } from '@tencent/workbench';
import { PicHandlerFeature } from './feature';
import { INSERT_TEXT_MENU_CONFIGS, TOOLBAR_ITEMS, toolbarConfig } from './config';
import * as React from 'react';
import { wrapIdForPic } from '@src/framework/workbench/util/wrap-id-util';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';

@Controller({
    menuItems: INSERT_TEXT_MENU_CONFIGS,
    toolbarItems: TOOLBAR_ITEMS,
})
export class PicHandlerController {
    public constructor(private readonly feature: PicHandlerFeature) {
    }

    @Toolbar(toolbarConfig.id, 'dropdownContent')
    @Toolbar(wrapIdForPic(toolbarConfig.id), 'dropdownContent')
    public insertDropdown() {
        return <MainMenu
            align="left" name={toolbarConfig.id} mode="menu" itemStyle={{ width: 166 }}/>;
    }

    @Toolbar(toolbarConfig.id, 'shouldHide')
    @Toolbar(wrapIdForPic(toolbarConfig.id), 'shouldHide')
    public shouldHidePicHandler() {
        return !(appConfigInstance.getConfig(ToolbarFileMenuConfig.picHandleToolbar as any) ?? true);
    }
}
